<template>
 <Row>
        <i-col span="12">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
         <FormItem label="角色名称" prop="name">
            <i-input v-model="formValidate.name" placeholder="请输入角色名称"></i-input>
        </FormItem>
        <FormItem label="权限" prop="role">
              <Select v-model="formValidate.privileges"  multiple style="width:260px">
                <Option v-for="item in privileges" :value="item.id" :key="item.id">{{ item.name }}</Option>
             </Select>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            <!-- <Button type="ghost" @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button> -->
        </FormItem>
    </Form>
     </i-col>
        <i-col span="12"></i-col>
    </Row>
  
</template>
<script>
import { mapState } from 'vuex'
import { rolename , addrole } from "../../api/roleapi";
export default {
  data() {
    const validateusername = (rule, value, callback) => {
      let para = {
        name: value
      };
      rolename(para).then(res => {
        let data = res.data;
        if (data.code == 1) {
          callback();
        } else {
          callback(new Error(data.message));
        }
      });
    };
    return {
      formValidate: {
        name: "",
        privileges:  [],
      },
      labelInValue:true,
      ruleValidate: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { validator: validateusername, trigger: "blur" }
        ]
      }
    };
  },
  computed: mapState({
    privileges: state => state.privileges,
    }),
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.addadmin();
        } else {
          this.$Message.error("请检查输入");
        }
      });
    },
    addadmin() {
      let para = this.formValidate;
      this.$Loading.start();
      addrole(para).then(res => {
         this.$Loading.finish();
         let data=res.data
          if(data.code==1){
              this.$Message.success(data.message);
              this.init()
            }else{
               self.$Message.error(data.message);
            }
      });
    },
    init() {
      this.formValidate = {
            name: "",
            privileges: [],
     
      };
    },
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/pages/role/add.vue